// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title_iVf6T","table":"table_A44Qv","date":"date_XwgDP","footer":"footer_idG2H","moreBtn":"moreBtn_ZKslL","ui_mask":"ui_mask_Ax+IE"};